'use client';

import Link from 'next/link';
import styled, { createGlobalStyle } from 'styled-components';

import { breakpoints, colors } from '@/styles/theme';

export const CookieConsentGlobalStyle = createGlobalStyle`
  .cookie-consent-banner {
    position: fixed;
    inset: auto 0 0 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;
    padding: 16px 24px;
    background: ${colors.dark};
    box-shadow: 0 -10px 30px rgba(21, 36, 56, 0.18);
    z-index: 1200;
  }

  .cookie-consent-banner__content {
    flex: 1 1 420px;
    margin: 0;
  }

  .cookie-consent-banner__actions {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
  }

  .cookie-consent-banner__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 44px;
    padding: 0 20px;
    border: 1px solid transparent;
    border-radius: 999px;
    background: ${colors.simba};
    color: ${colors.light};
    font-size: 14px;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    transition: opacity 0.2s ease, transform 0.2s ease, background 0.2s ease;
  }

  .cookie-consent-banner__button:hover {
    opacity: 0.92;
    transform: translateY(-1px);
  }

  .cookie-consent-banner__button--decline {
    border-color: rgba(255, 255, 255, 0.2);
    background: transparent;
    color: ${colors.light};
  }

  @media (max-width: ${breakpoints.tablet}) {
    .cookie-consent-banner {
      flex-direction: column;
      align-items: stretch;
      padding: 16px;
    }

    .cookie-consent-banner__content {
      flex-basis: auto;
    }

    .cookie-consent-banner__actions {
      width: 100%;
      justify-content: stretch;
    }

    .cookie-consent-banner__button {
      flex: 1 1 0;
      width: 100%;
    }
  }
`;

export const ConsentContent = styled.span`
  display: inline;
  color: ${colors.light};
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6;
`;

export const ConsentLink = styled(Link)`
  color: ${colors.light};
  text-decoration: underline;
  text-underline-offset: 2px;

  &:hover {
    opacity: 0.85;
  }
`;
